import { z } from 'zod';
/**
 * Каталог знакомства и энциклопедии, сцены сюжета, отметки «уже видел» и настройки игрока
 * (SPEC.md, разделы 15.7, 17.3, 19, 20.4).
 */
/** Основной язык контента; остальные языки добавляются ключами рядом с ним. */
export const DEFAULT_LANGUAGE = 'ru';
/** Идентификатор элемента каталога или сцены: строчные латинские буквы, цифры и дефис. */
export const CONTENT_ID_PATTERN = /^[a-z0-9-]{1,64}$/;
export const CATALOG_KINDS = [
    'rule',
    'microbe',
    'modifier',
    'vessel',
    'boss',
    'boss-ability',
    'ability',
    'attack',
    'role',
    'effect',
];
export const SCENE_KINDS = ['comic', 'boss-intro', 'victory'];
/** Действия управления, которые игрок может переназначить (SPEC.md, 15.2: «C», «V»). */
export const CONTROL_ACTIONS = [
    'move-left',
    'move-right',
    'rotate-clockwise',
    'rotate-counterclockwise',
    'soft-drop',
    'hard-drop',
    'ability',
    'duel-ability',
    'pause',
];
const volumeSchema = z.number().min(0).max(1);
/** Клавиша — значение `KeyboardEvent.code` («ArrowLeft», «KeyZ», «Space»). */
const keyCodeSchema = z.string().regex(/^[A-Za-z0-9]{1,32}$/);
export const settingsSchema = z.strictObject({
    /** Переназначенные клавиши; отсутствующее действие — клавиша по умолчанию клиента. */
    keys: z
        .partialRecord(z.enum(CONTROL_ACTIONS), keyCodeSchema)
        .refine((keys) => new Set(Object.values(keys)).size === Object.values(keys).length, {
        message: 'одна клавиша — одно действие',
    }),
    sound: z.strictObject({
        music: volumeSchema,
        effects: volumeSchema,
        voices: volumeSchema,
        musicMuted: z.boolean(),
        effectsMuted: z.boolean(),
    }),
    accessibility: z.strictObject({
        /** system — как в настройках системы (`prefers-reduced-motion`). */
        reducedMotion: z.enum(['system', 'on', 'off']),
        /** Подсказки в бою и карточки знакомства (SPEC.md, 15.7: подсказки можно отключить). */
        hints: z.boolean(),
    }),
});
export const DEFAULT_SETTINGS = Object.freeze({
    keys: {},
    sound: { music: 0.6, effects: 0.8, voices: 0.8, musicMuted: false, effectsMuted: false },
    accessibility: { reducedMotion: 'system', hints: true },
});
const contentIdsSchema = z.array(z.string().regex(CONTENT_ID_PATTERN)).max(100).default([]);
/** Отметки «уже видел»: повторная отметка не ошибка и не создаёт дублей. */
export const markSeenSchema = z.strictObject({
    /** Карточки знакомства — идентификаторы каталога. */
    intros: contentIdsSchema,
    scenes: contentIdsSchema,
});
//# sourceMappingURL=profile.js.map